import { MNIDashboard } from '@/core/preferences/export';
import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export default function DashboardAddWidgetSelectDashboardModal({
  showAddWidgetModal,
  dashboards,
  selectedDashboardValue,
  onResolve,
}: {
  showAddWidgetModal: boolean;
  dashboards: MNIDashboard[];
  selectedDashboardValue: MNIDashboard | undefined;
  onResolve: (res: boolean, dashboard?: MNIDashboard) => void;
}) {
  const [selectedDashboard, setSelectedDashboard] = useState<MNIDashboard | undefined>(
    selectedDashboardValue ?? dashboards[0],
  );

  useEffect(() => {
    if (showAddWidgetModal) {
      setSelectedDashboard(selectedDashboardValue ?? dashboards[0]);
    }
    // eslint-disable-next-line
  }, [showAddWidgetModal]);

  return (
    <Modal
      show={showAddWidgetModal}
      onHide={() => {
        onResolve(false);
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="p-3">
        <h4 className="text-center">Add widget</h4>
        <div className="text-center my-3">
          <p>Select a dashboard to add the widget to:</p>
        </div>
        <div className="text-center my-3">
          <select
            className="form-select"
            value={selectedDashboard?.id}
            onChange={e =>
              setSelectedDashboard(
                dashboards.find(dashboard => dashboard.id === e.target.value) ?? undefined,
              )
            }
          >
            {dashboards.map(dashboard => (
              <option key={dashboard.id} value={dashboard.id}>
                {dashboard.name}
              </option>
            ))}
          </select>
        </div>
        <Modal.Footer>
          <Button
            style={{ height: '40px', fontFamily: 'Inter' }}
            className="btn btn-warning"
            onClick={() => {
              onResolve(false);
            }}
          >
            Cancel
          </Button>
          <Button
            style={{ height: '40px', fontFamily: 'Inter' }}
            className="btn btn-success"
            onClick={() => {
              onResolve(true, selectedDashboard);
            }}
          >
            Add
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}
